export const chooseBestFit = sizes => {
    const widths = Object.keys(sizes)
        .map(Number)
        .sort((a, b) => a - b)
    const maxWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

    let match = widths.find(width => width >= maxWidth)
    if (undefined === match) match = widths[widths.length - 1]

    return sizes[match].src
}

export const extractSizes = attachment => {
    const extractStrategy = attachment.mediaDetails ? extractSizesFromPost : extractSizesFromMeta
    return extractStrategy(attachment)
}

const extractSizesFromMeta = ({ url, width, sizes }) => ({
    [width]: {
        src: url,
    },
    [sizes.largeWidth]: {
        src: sizes.large,
    },
    [sizes.mediumLargeWidth]: {
        src: sizes.mediumLarge,
    },
    [sizes.mediumWidth]: {
        src: sizes.medium,
    },
    [sizes.thumbnailWidth]: {
        src: sizes.thumbnail,
    },
})

const extractSizesFromPost = ({
    mediaDetails: {
        sizes: { full, large, mediumLarge, medium, thumbnail },
    },
}) => ({
    [full.width]: {
        src: full.sourceUrl,
    },
    [large.width]: {
        src: large.sourceUrl,
    },
    [mediumLarge.width]: {
        src: mediumLarge.sourceUrl,
    },
    [medium.width]: {
        src: medium.sourceUrl,
    },
    [thumbnail.width]: {
        src: thumbnail.sourceUrl,
    },
})

export class Image extends Component {
    constructor(props) {
        super(props)

        const { image } = this.props

        this.state = {
            src: image ? chooseBestFit(extractSizes(this.props.image)) : '',
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { image } = this.props

        if (image !== nextProps.image)
            this.setState({
                src: nextProps.image ? chooseBestFit(extractSizes(nextProps.image)) : '',
            })
    }

    render() {
        const { background = false, image, ...otherProps } = this.props
        const { src } = this.state

        return background ? (
            <div style={{ backgroundImage: `url(${src})` }} {...otherProps}>
                {this.props.children}
            </div>
        ) : (
            <img src={src} {...otherProps} />
        )
    }
}
